import { useEffect, useState, useCallback } from "react";

import { VscLockSmall } from "react-icons/vsc";
import Select from "react-select";
import { toast } from "react-toastify";
import { propertySaleTypes, underOfGovernances } from "../../Enum";
import LocationService from "../../components/Services/LocationService";
import CustomInput from "../../components/common/CustomInput";
import Accordion from "../../components/SetupComponents/PropertiesComponents/Accordion/Accordion";
import { GLPagePropertyTypeList } from "../../Enum/GLPageEnumConstants";
import CustomSelect from "../../components/common/CustomSelect";
import UserService from "../../GlobalSetupComponents/Services/UserService";
import ProspectPropertyService from "../Service/ProspectPropertyService";
import { showInfoToast, showSuccessToast } from "../../components/Constant/Notification";

const BasicInfo = ({
  propertyInfo,
  setPropertyInfo,
  handlePropertyInfoChange,
}) => {


  const [locationData, setLocationData] = useState([]);
  const [sourceBy , setSourceBy] = useState(null);
  const [propertyNameOptions, setPropertyNameOptions] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    const fetchLocationData = async () => {
      try {
        const response = await LocationService.fetchLocation();
        const rawData = response.data || {};
        const formattedData = Array.isArray(rawData)
          ? rawData.map((item) => ({
              label: item.label || item.name || "",
              id: item.id,
            }))
          : Object.entries(rawData).map(([label, id]) => ({
              label,
              id,
            }));
        setLocationData(formattedData);
      } catch (error) {
        console.error("Error fetching location data:", error);
        toast.error("Failed to load locations");
      }
    };
    fetchLocationData();
  }, []);

  const fetchUserRoleBasedData = async() => {
    try{
      const role = {
        label: "Procurer",
        value: "TiSq7g9gUEt8q6bvl1Je",
       }
      const response = await UserService.getUserRoleBasedNames(role.value);
      const data = response.data?.users || {};
      setSourceBy(data || null);
    }catch(error){
      console.error("Error fetching user role based data:", error);
    }
  }

  useEffect(() => {
    fetchUserRoleBasedData();
  }, []);


  useEffect(() => {
    const fetchNames = async () => {
      try {
        const data = await ProspectPropertyService.getPropertyNameList();
        const options = data?.properties?.map((item) => ({
          value: item.name,
          label: item.name,
        })) || [];
       
        setPropertyNameOptions(options);
        setFilteredOptions(options);
      } catch (err) {
        console.error("Error fetching property names:", err);
        setPropertyNameOptions([]);
        setFilteredOptions([]);
      }
    };
    fetchNames();
  }, []);

  // Enhanced search handler for property names
  const handlePropertyNameInputChange = useCallback((inputValue, actionMeta) => {
    setInputValue(inputValue);
    
    if (actionMeta.action === 'input-change') {
     
      handlePropertyInfoChange({
        target: { name: "name", value: inputValue },
      });

   
      const filtered = propertyNameOptions.filter(option =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      );

      // Always show filtered results plus option to create new if input has value
      const optionsToShow = [...filtered];
      
      // Add "Create new" option if input doesn't exactly match existing options
      if (inputValue.trim() && !propertyNameOptions.some(option => 
        option.label.toLowerCase() === inputValue.toLowerCase()
      )) {
        optionsToShow.push({
          value: inputValue.trim(),
          label: `Create "${inputValue.trim()}"`,
          isCustom: true
        });
      }

      setFilteredOptions(optionsToShow);
    }
  }, [propertyNameOptions, handlePropertyInfoChange]);

  const handlePropertyNameChange = (selectedOption) => {
    if (selectedOption) {
      handlePropertyInfoChange({
        target: {
          name: "name",
          value: selectedOption.value,
        },
      });
      
      if (selectedOption.isCustom) {
        showInfoToast(`Added "${selectedOption.value}" as new property`);
      }
      
      setInputValue(selectedOption.value);
    } else {
      handlePropertyInfoChange({
        target: {
          name: "name",
          value: "",
        },
      });
      setInputValue("");
    }
  };

  const locationOptions = locationData.map((loc) => ({
    value: loc.id,
    label: loc.label,
  }));

  
  const accordionItems = [
  
        {
          title: "Basic Info",
          content: (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pb-10">
              {/* Property Name */}
              <div className="grid grid-cols-[40%_60%] items-center gap-2">
                <label className="text-sm font-medium text-gray-700 flex items-center">
                  <span className="w-1 h-5 bg-red-400 mr-2 rounded-sm"></span>
                  Property Name
                </label>
                <CustomSelect
                  value={
                    propertyInfo?.name
                      ? { label: propertyInfo.name, value: propertyInfo.name }
                      : null
                  }
                  options={filteredOptions}
                  isClearable
                  isSearchable
                  onChange={handlePropertyNameChange}
                  onInputChange={handlePropertyNameInputChange}
                  inputValue={inputValue}
                  placeholder="Search or Type Property Name"
                  className="w-full"
                  noOptionsMessage={({ inputValue }) => 
                    inputValue ? `No results found. Keep typing to add "${inputValue}"` : "Start typing to search properties"
                  }
                  formatOptionLabel={(option, { context }) => (
                    <div className="flex items-center justify-between">
                      <span className={option.isCustom ? "text-blue-600 font-medium" : ""}>
                        {option.label}
                      </span>
                      {option.isCustom && (
                        <span className="text-xs bg-blue-100 text-blue-600 px-2 py-1 rounded">
                          NEW
                        </span>
                      )}
                    </div>
                  )}
                  filterOption={() => true} // Disable default filtering since we handle it manually
                />
              </div>
      
              {/* Property Type */}
              <div className="grid grid-cols-[40%_60%] items-center gap-2">
              <label className="text-sm font-medium text-gray-700 flex items-center">
                <span className="w-1 h-5 bg-red-400 mr-2 rounded-sm"></span>Property Type</label>
                <CustomSelect
                  options={GLPagePropertyTypeList.map((item)=>(
                    { value: item?.id || "", label: item?.label || "" }
                  ))}
                  value={propertyInfo?.propertyType}
                  onChange={
                    (selectedOption) =>
                      handlePropertyInfoChange({
                        target: { name: "propertyType", value: selectedOption  || "" },
                      })

                  }
                  placeholder="Property Type"
                  className="w-full"
                  isSearchable
                />
               
              </div>

              {/* Property Type */}
              <div className="grid grid-cols-[40%_60%] items-center gap-2">
              <label className="text-sm font-medium text-gray-700 flex items-center">
              <span className="w-1 h-5 bg-red-400 mr-2 rounded-sm"></span>
                  Property Sale Type</label>
                <CustomSelect
                 options={propertySaleTypes.map((item)=>(
                  {
                    value: item?.id || "",
                    label: item?.label || "",
                  }
                 ))}
                  value={propertyInfo?.propertySaleType}
                  onChange={(selectedOption) =>
                    handlePropertyInfoChange({
                      target: { name: "propertySaleType", value: selectedOption  || "" },
                    })
                  }
                  placeholder="Property Sale Type "
                  className="w-full"
                  isSearchable
                />
               
              </div>
      
              {/* Overall Sq.Ft */}
              <div className="grid grid-cols-[40%_60%] items-center gap-2">
                <label className="text-sm font-medium text-gray-700 flex items-center">
                  <span className="w-1 h-5 bg-red-400 mr-2 rounded-sm"></span>
                  Overall Area
                </label>
                <div className="flex gap-2">
                  <input
                  type="text"
                  name="overAllArea"
                  disabled={propertyInfo?.overallAreaType ? false : true}
                  value={propertyInfo?.overAllArea || ""}
                  onChange={(e) => {
                    if (e.target.value.length <= 30) handlePropertyInfoChange(e);
                  }}
                  className="px-3 py-2 input-focus rounded-md w-full"
                  placeholder={`${propertyInfo?.overallAreaType ? "Type" : "Select Area Type ->"}`}
                />
                <CustomSelect
                  options={[
                    { value: "sqft", label: "sqft" },
                    { value: "cent", label: "cent" },
                    { value: "ground", label: "ground" },
                    { value: "acres", label: "acres" }, 
                  ]}
                  value={propertyInfo?.overallAreaType || null}
                  onChange={(selectedOption) =>
                    handlePropertyInfoChange({
                      target: { name: "overallAreaType", value: selectedOption || "" },
                    })
                  }
                  placeholder=" Area Type"
                />
                </div>
              </div>
      
              {/* Property Non-client */}
              <div className="grid grid-cols-[40%_60%] items-center gap-2">
                <label className="text-sm font-medium text-gray-700">Property No/Extent</label>
                <input
                  type="text"
                  name="propertyNo"
                  value={propertyInfo?.propertyNo || ""}
                  onChange={handlePropertyInfoChange}
                  className="px-3 py-2 input-focus rounded-md w-full"
                  placeholder="Enter E.g 1,2,3"
                />
              </div>
      
              {/* Property Sourced by */}
              <div className="grid grid-cols-[40%_60%] items-center gap-2">
                <label className="text-sm font-medium text-gray-700 flex items-center">
                  <span className="w-1 h-5 bg-red-400 mr-2 rounded-sm"></span>
                  Property Sourced by
                </label>
                <CustomSelect
                  options={sourceBy}
                  value={propertyInfo?.propertySourcedBy}
                  onChange={(selectedOption) =>
                    handlePropertyInfoChange({
                      target: { name: "propertySourcedBy", value: selectedOption || "" },
                    })
                  }
                  isDisabled={true} 
                  placeholder="Select Name"
                  className="w-full"
                  isSearchable
                />
              </div>
  
      
              {/* Seller Name */}
              <div className="grid grid-cols-[40%_60%] items-center gap-2">
              <label className="text-sm font-medium text-gray-700 flex items-center">
                  <span className="w-1 h-5 bg-red-400 mr-2 rounded-sm"></span>
                  Seller Name
                </label>
               
                <input
                  type="text"
                  name="propertySellerName"
                  value={propertyInfo?.propertySellerName || ""}
                  onChange={handlePropertyInfoChange}
                  className="px-3 py-2 input-focus rounded-md w-full"
                  placeholder="Type Name"
                />
              </div>
      
              {/* Seller Phone */}
              <div className="grid grid-cols-[40%_60%] items-center gap-2">
              
              <label className="text-sm font-medium text-gray-700 flex items-center">
                  <span className="w-1 h-5 bg-red-400 mr-2 rounded-sm"></span>
                  Seller Phone Number
                </label>
                <CustomInput
                  type="number"
                  name="propertySellerPhoneNumber"
                  value={propertyInfo?.propertySellerPhoneNumber || ""}
                  onChange={handlePropertyInfoChange}
                  maxLength={10}
                  className="px-3 py-2 input-focus rounded-md w-full"
                  placeholder="Type Phone Number"
                />
              </div>
      
            </div>
          ),
        },
      
      

    {
      title: "Address Info",
      content: (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="w-full h-70 rounded-md overflow-hidden border">
            {propertyInfo?.geoLocation ? (
              <iframe
                src={`https://www.google.com/maps?q=${propertyInfo.geoLocation}&output=embed`}
                className="w-full h-full"
                title="Map Preview"
                allowFullScreen
                loading="lazy"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-gray-400 bg-gray-100">
                Map preview will appear here
              </div>
            )}
          </div>

          <div className="space-y-4">
            <div className="flex items-center">
              <label className="w-[40%] block text-sm font-medium text-gray-700">
                <span className="border-red-400 border-l-4 mr-1 rounded-md"></span>
                Location
              </label>
              <div className="w-[60%]">
                <CustomSelect
                  options={locationOptions}
                  value={propertyInfo?.location || null}
                  onChange={(selectedOption) =>
                    handlePropertyInfoChange({
                      target: { name: "location", value: selectedOption || "" },
                    })
                  }
                  placeholder="Select Location" 
                  className="w-full"
                  isSearchable
                />
              </div>
            </div>

            <div className="flex items-center">
              <label className="w-[40%] block text-sm font-medium text-gray-700">
                <span className="border-red-400 border-l-4 mr-1 rounded-md"></span>
                Type latitude and longitude
              </label>
              <input
                type="text"
                name="geoLocation"
                value={propertyInfo?.geoLocation || ""}
                onChange={(e) => {
                  const cleaned = e.target.value
                    .replace(/°/g, "")
                    .replace(/[NSEW]/gi, "")
                    .replace(/\s+/g, "");

                  handlePropertyInfoChange({
                    target: {
                      name: "geoLocation",
                      value: cleaned,
                    },
                  });
                }}
                placeholder="eg 12345,08023"
                className="w-[60%] px-3 py-2 border rounded-md input-focus"
              />
            </div>

            <div className="flex items-start">
              <label className="w-[40%] block text-sm font-medium text-gray-700 mt-2">
                
                Address
              </label>
              <textarea
                name="address"
                value={propertyInfo?.address || ""}
                onChange={handlePropertyInfoChange}
                placeholder="Address"
                className="w-[60%] h-20 px-3 py-2 border rounded-md input-focus"
              />
            </div>

            <div className="flex items-start">
              <label className="w-[40%] block text-sm font-medium text-gray-700 mt-2">
                Landmark
              </label>
              <textarea
                name="landmark"
                rows={2}
                value={propertyInfo?.landmark || ""}
                onChange={handlePropertyInfoChange}
                className="w-[60%] px-3 py-2 input-focus rounded-md"
                placeholder="Landmark"
              />
            </div>

            <div className="flex items-center">
              <label className="w-[40%] text-nowrap block text-sm font-medium text-gray-700">
                Link
              </label>
              <input
                type="text"
                name="locationLink"
                value={propertyInfo?.locationLink || ""}
                onChange={handlePropertyInfoChange}
                placeholder="Enter G-Map link only"
                className="w-[60%] px-3 py-2 border rounded-md input-focus"
              />
            </div>
          </div>
        </div>
      ),
    },
   
    
  ];

  return (
    <div className="bg-white rounded-lg  shadow-sm">
      <Accordion items={accordionItems} />
    </div>
  );
};

export default BasicInfo;
